module.exports = __webpack_public_path__ + "static/media/profile_inactive_v2.76d132ea.svg";